module.exports = __webpack_public_path__ + "img/vieplus.4222a026.png";